(function(){
  function root(){ return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  window.pbaAddToCart = function(items){
    var drawer = document.querySelector('cart-drawer');
    var onCart = /^\/cart\/?$/.test(location.pathname);
    var body = { items: items };
    if (drawer && !onCart) body.sections = 'cart-drawer,cart-icon-bubble';
    return fetch(root() + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
      .then(function(j){
        var canDrawer = drawer && !onCart && j.sections && typeof drawer.renderContents === 'function';
        if (canDrawer) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(j);
          document.dispatchEvent(new CustomEvent('pba:cart:changed'));
        } else {
          window.location.href = root() + 'cart';
        }
        return j;
      });
  };
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-pba-quick-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true; var label = b.textContent; b.textContent = 'Adding\u2026';
    window.pbaAddToCart([{ id: parseInt(b.getAttribute('data-variant-id'), 10), quantity: 1 }])
      .catch(function(){ b.disabled = false; b.textContent = label; });
  });
})();
